/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/**
 * Regular expressions to validate passwords.
 */
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export abstract class PasswordRegex {
    // eslint-disable-next-line max-len
    public static readonly defaultRegex = /^((?=.*[a-z])(?=.*[A-Z])(?=.*\d)|(?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9])|(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z0-9])|(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]))([A-Za-z\d@#$%^&*\-_+=[\]{}|\\:',?/`~'();!]|\.(?!@)){8,16}$/;
}
